import styled from "styled-components";
import { color, typeStyle, units } from "@m/alchemy-theme";
export const Wrapper = styled.div `
  width: 100%;
`;
export const MessageWrapper = styled.div `
  display: flex;
`;
export const Message = styled.div `
  ${typeStyle("captionS")};
  color: ${color("typeMeta")};
  display: flex;
  flex-grow: 1;
  flex-direction: column;
  margin-bottom: ${units(0.5)};
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;

  &:last-child {
    text-align: right;
  }
`;
